import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import { CREATE_BULK_PASSPORT_IDENTITY_PROVIDERS_URL, CREATE_EVENT_PASSPORT_IDENTITY_PROVIDERS_URL, GET_EVENT_PASSPORT_IDENTITY_PROVIDERS_URL, GET_FUSION_PASSPORT_IDENTITY_PROVIDERS_URL, GET_PASSPORT_IDENTITY_PROVIDERS_URL, UPDATE_EVENT_PASSPORT_IDENTITY_PROVIDERS_URL, UPDATE_PASSPORT_IDENTITY_PROVIDERS_URL } from '../../constants/api/passport-attendee-sso-api.constants';
import { FusionIdentityProviderResponseDAO, IdentityProviderMappingsResponse, IdentityProviderRequestDAO, IdentityProviderResponseDAO, IEventIdentityProviderMapping, IEventIdentityProviderRequestDAO, IPassportAttendeeSSODAO, IPassportAttendeeSSORequestParams } from '../passport-attendee-sso.dao';

class PassportAttendeeSSODAO extends IPassportAttendeeSSODAO {
    constructor(
        @IoC.Inject private readonly apiClient: IApiClient
    ) {
        super();
    }

    public async getPassportIdentityProviders(params: IPassportAttendeeSSORequestParams): Promise<IdentityProviderResponseDAO[]> {
        const response = await this.apiClient.get<IdentityProviderResponseDAO[]>(GET_PASSPORT_IDENTITY_PROVIDERS_URL, params);
        return response.parsedResponse;
    }

    public async getFusionPassportIdentityProviders(): Promise<FusionIdentityProviderResponseDAO[]> {
        const response = await this.apiClient.get<FusionIdentityProviderResponseDAO[]>(GET_FUSION_PASSPORT_IDENTITY_PROVIDERS_URL);
        return response.parsedResponse;
    }

    public async createBulkPassportIdentityProviders(params: IdentityProviderMappingsResponse): Promise<IdentityProviderMappingsResponse> {
        const response = await this.apiClient.post<IdentityProviderMappingsResponse>(CREATE_BULK_PASSPORT_IDENTITY_PROVIDERS_URL, params);
        return response.parsedResponse;
    }

    public async updatePassportIdentityProvider(params: IdentityProviderRequestDAO): Promise<IdentityProviderResponseDAO> {
        const response = await this.apiClient.put<IdentityProviderResponseDAO>(UPDATE_PASSPORT_IDENTITY_PROVIDERS_URL, params);
        return response.parsedResponse;
    }

    public async getEventPassportIdentityProviders(params: {accountId: number; eventId: number}): Promise<IEventIdentityProviderMapping[]> {
        const response = await this.apiClient.get<IEventIdentityProviderMapping[]>(GET_EVENT_PASSPORT_IDENTITY_PROVIDERS_URL, params);
        return response.parsedResponse;
    }


    public async createEventPassportIdentityProvider(params: IEventIdentityProviderRequestDAO): Promise<IEventIdentityProviderMapping> {
        const response = await this.apiClient.post<IEventIdentityProviderMapping>(CREATE_EVENT_PASSPORT_IDENTITY_PROVIDERS_URL, params);
        return response.parsedResponse;
    }

    public async updateEventPassportIdentityProvider(params: IEventIdentityProviderRequestDAO): Promise<IEventIdentityProviderMapping> {
        const response = await this.apiClient.put<IEventIdentityProviderMapping>(UPDATE_EVENT_PASSPORT_IDENTITY_PROVIDERS_URL, params);
        return response.parsedResponse;
    }
}

export { PassportAttendeeSSODAO };